import { useNavigate } from "react-router-dom";
import { Company, JobAd } from "../lib/models";
import H3 from "./forms/H3";
import { useContext } from "react";
import { CompanyContext } from "../contexts/CompanyContext";
import { EMPTY_FILENAME } from "../lib/utils";
import Badge from "./Badge";
import { cn } from "./helpers";

const JobAdCard: React.FC<{ jobAd: JobAd; company: Company }> = ({
  jobAd,
  company,
}) => {
  const navigate = useNavigate();
  const { setActiveJobAd } = useContext(CompanyContext);

  const noBackgroundImage = jobAd.backgroundImageFilename === EMPTY_FILENAME;
  return (
    <div
      onClick={() => {
        setActiveJobAd(jobAd);
        navigate(`/${company.name}/${company?.companyId}/ad/${jobAd.jobAdId}`);
      }}
      key={jobAd.jobAdId}
      className={cn(
        `border border-gray-200 rounded-l-[24px] rounded-tr-[24px] cursor-pointer hover:opacity-95 overflow-hidden`,
        "grid grid-cols-1"
      )}
    >
      <div className="relative bg-pitchlerGray rounded-bl-[24px] overflow-hidden aspect-video">
        {jobAd.backgroundImageUrl && !noBackgroundImage && (
          <img
            className="absolute inset-0 object-cover h-full w-full"
            src={jobAd.backgroundImageUrl}
            alt=""
          />
        )}
      </div>

      <div className={`text-center p-4 flex flex-col gap-2`}>
        <span className={`line-clamp-3`}>
          <H3 text={jobAd.title} />
        </span>

        <div className="flex gap-2 items-center justify-center mb-2">
          {/* flex-wrap md:flex-nowrap */}
          {jobAd?.city && <Badge text={jobAd.city} />}
          {jobAd?.employmentType && (
            <Badge text={jobAd.employmentType} allowShrinkage />
          )}
          {jobAd?.workLocation && <Badge text={jobAd.workLocation} />}
        </div>
      </div>
    </div>
  );
};

export default JobAdCard;
